import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CouponsManagementTable from "../../components/CouponsManagement/CouponsManagementTable";
import CreateCoupons from "../../components/CouponsManagement/CreateCoupons";
import CustomersTable from "../../components/Customers/CustomersTable";
import CreateAdminUsers from "../../components/Customers/CreateAdminUsers";




const CreateCustomersPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>

                <Breadcrumb title="Create Customers" subtitle={"Customers"} subUrl={"customers"} />
                <CreateAdminUsers />





            </MasterLayout>
        </>
    );
};

export default CreateCustomersPage;
